import { formatValueToLabel } from '@openx/components-table/ChipFilters/NumberFilter/utils.ts';
import { parseMultiValueFilter } from '@openx/utils/lib/multiValueFilter.ts';
import type { TFunction } from 'i18next';
import type { SegmentsListFilters } from './defaultSegmentsCriteria.ts';

export type AppliedSegmentsFilterDisplay = {
  label: string;
  value: string;
};

const NUMERIC_FILTER_KEYS = new Set(['reach', 'price_cpm', 'price_pom']);
const MULTI_VALUE_FILTER_KEYS = new Set([
  'segment_category',
  'segment_sub_category',
  'segment_type',
  'provider',
  'account',
  'regions',
  'countries',
]);

const getFilterLabels = (t: TFunction): Record<keyof SegmentsListFilters, string> => ({
  phrase: t('Search'),
  account: t('Data Partner'),
  provider: t('Data Provider'),
  status: t('Status'),
  regions: t('Region'),
  countries: t('Country'),
  reach: t('Reach'),
  segment_category: t('Category'),
  segment_sub_category: t('Sub Category'),
  segment_type: t('Type'),
  price_pom: t('Percent of Media'),
  price_cpm: t('Fixed CPM'),
  updated_date: t('Last Modified'),
  created_date: t('Created'),
});

const formatFilterValue = (key: keyof SegmentsListFilters, value: string): string => {
  if (NUMERIC_FILTER_KEYS.has(key)) {
    return formatValueToLabel(value);
  }

  if (MULTI_VALUE_FILTER_KEYS.has(key)) {
    return parseMultiValueFilter(value).join('; ');
  }

  if (key === 'status') {
    return value
      .split(',')
      .map(item => item.trim())
      .filter(Boolean)
      .join('; ');
  }

  return value;
};

export const getAppliedSegmentsFiltersDisplay = (
  filters: SegmentsListFilters | undefined,
  t: TFunction
): AppliedSegmentsFilterDisplay[] => {
  if (!filters) {
    return [];
  }

  const labels = getFilterLabels(t);

  return (Object.keys(labels) as Array<keyof SegmentsListFilters>).flatMap(key => {
    const rawValue = filters[key];

    if (rawValue === undefined || rawValue === null || rawValue === '') {
      return [];
    }

    return [
      {
        label: labels[key],
        value: formatFilterValue(key, String(rawValue)),
      },
    ];
  });
};
